export const attachments = [
  {
    id: '1',
    attachment_name: 'Dummy1.pdf',
  },
  {
    id: '2',
    attachment_name: 'Dummy2.jpg',
  },
  {
    id: '3',
    attachment_name: 'Dummy3.pdf',
  },
  {
    id: '4',
    attachment_name: 'Dummy4.jpg',
  },
  {
    id: '5',
    attachment_name: 'Dummy5.pdf',
  },
  {
    id: '6',
    attachment_name: 'Dummy6.jpg',
  },
]

export const emailContent = `<div style="font-family: Arial, sans-serif; line-height: 1.6; color: #333;">
  <h2 style="color: #0056b3;">Welcome to Our Service!</h2>
  <p>Dear <strong>John Doe</strong>,</p>
  <p>Thank you for signing up! We're excited to have you on board.</p>
  
  <p>Please verify your email by clicking the button below:</p>
  <p>
    <a href="https://example.com/verify" 
       style="background-color: #28a745; color: white; padding: 10px 15px; text-decoration: none; border-radius: 5px;">
      Verify Email
    </a>
  </p>

  <p>If you did not sign up, please ignore this email.</p>

  <hr style="border: none; border-top: 1px solid #ccc; margin: 20px 0;">

  <p style="font-size: 12px; color: #777;">
    Regards, <br>
    <strong>The Example Team</strong> <br>
    <a href="https://example.com" style="color: #0056b3;">Visit our website</a>
  </p>
</div>`
